var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
var PhotoFrame = /** @class */ (function (_super) {
    __extends(PhotoFrame, _super);
    function PhotoFrame() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapperElement = null;
        _this.state = {
            wrapperWidth: null,
            wrapperHeight: null,
        };
        return _this;
    }
    PhotoFrame.prototype.componentDidMount = function () {
        this.handleWindowResize = this.handleWindowResize.bind(this);
        window.addEventListener('resize', this.handleWindowResize);
    };
    PhotoFrame.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
    };
    PhotoFrame.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (element) { return _this.setWrapperRef(element); }, className: "c-photo-frame__wrapper" },
            React.createElement("div", { className: this.getFrameClasses(), style: this.getFrameStyle() },
                React.createElement("div", { className: this.getOverlayFrameClasses(), style: this.getOverlayFrameStyle() }),
                React.createElement("div", { className: "c-photo-frame__content", style: this.getMatboardStyle() },
                    React.createElement("div", { className: "c-photo-frame__overlay-matboard", style: this.getOverlayMatboardStyle() }),
                    this.props.children))));
    };
    PhotoFrame.prototype.handleWindowResize = function () {
        if (!this.wrapperElement) {
            return;
        }
        this.updateWrapperDimensions(this.wrapperElement);
    };
    PhotoFrame.prototype.setWrapperRef = function (element) {
        this.updateWrapperDimensions(element);
        if (this.wrapperElement) {
            return;
        }
        this.wrapperElement = element;
    };
    PhotoFrame.prototype.updateWrapperDimensions = function (element) {
        if (!element) {
            return;
        }
        if (this.state.wrapperWidth === element.clientWidth && this.state.wrapperHeight === element.clientHeight) {
            return;
        }
        this.setState({
            wrapperWidth: element.clientWidth,
            wrapperHeight: element.clientHeight,
        });
    };
    PhotoFrame.prototype.getFrameClasses = function () {
        var classes = "c-photo-frame";
        if (this.props.crop) {
            classes = classes + " c-photo-frame--crop";
        }
        if (this.props.shadow) {
            classes = classes + " c-photo-frame--shadow";
        }
        return classes;
    };
    PhotoFrame.prototype.getFrameStyle = function () {
        var _a, _b, _c, _d;
        var wrapperWidth = this.state.wrapperWidth;
        var wrapperHeight = this.state.wrapperHeight;
        if (!wrapperWidth || !wrapperHeight) {
            return {};
        }
        var outerSize = this.props.photo.getOuterSize(wrapperWidth, wrapperHeight);
        var frameSizes = this.props.noFrame
            ? null
            : this.props.photo.getFrameSizes(wrapperWidth, wrapperHeight);
        if (!outerSize) {
            return {};
        }
        return {
            width: outerSize.width,
            height: outerSize.height,
            paddingTop: (_a = frameSizes === null || frameSizes === void 0 ? void 0 : frameSizes.top) !== null && _a !== void 0 ? _a : 0,
            paddingRight: (_b = frameSizes === null || frameSizes === void 0 ? void 0 : frameSizes.right) !== null && _b !== void 0 ? _b : 0,
            paddingBottom: (_c = frameSizes === null || frameSizes === void 0 ? void 0 : frameSizes.bottom) !== null && _c !== void 0 ? _c : 0,
            paddingLeft: (_d = frameSizes === null || frameSizes === void 0 ? void 0 : frameSizes.left) !== null && _d !== void 0 ? _d : 0,
        };
    };
    PhotoFrame.prototype.getMatboardStyle = function () {
        var wrapperWidth = this.state.wrapperWidth;
        var wrapperHeight = this.state.wrapperHeight;
        if (!wrapperWidth || !wrapperHeight) {
            return {};
        }
        var matboardSizes = this.props.photo.getMatboardSizes(wrapperWidth, wrapperHeight, !this.props.noFrame);
        if (!matboardSizes) {
            return {};
        }
        return {
            paddingTop: matboardSizes.top,
            paddingRight: matboardSizes.right,
            paddingBottom: matboardSizes.bottom,
            paddingLeft: matboardSizes.left,
        };
    };
    PhotoFrame.prototype.getOverlayMatboardStyle = function () {
        var wrapperWidth = this.state.wrapperWidth;
        var wrapperHeight = this.state.wrapperHeight;
        if (!wrapperWidth || !wrapperHeight) {
            return {};
        }
        var matboardSizes = this.props.photo.getMatboardSizes(wrapperWidth, wrapperHeight, !this.props.noFrame);
        if (!matboardSizes) {
            return {};
        }
        // the frame already contains the matboard
        // so dont need to show it as a border
        return {
        // borderStyle: 'solid',
        // borderColor: 'rgb(252, 186, 3)',
        // borderTopWidth: matboardSizes.top,
        // borderRightWidth: matboardSizes.right,
        // borderBottomWidth: matboardSizes.bottom,
        // borderLeftWidth: matboardSizes.left,
        };
    };
    PhotoFrame.prototype.getOverlayFrameClasses = function () {
        var defaultClass = "c-photo-frame__overlay-frame";
        if (!this.props.noFrame) {
            return defaultClass + " c-photo-frame__overlay-frame--" + this.props.photo.orientation;
        }
        return defaultClass;
    };
    PhotoFrame.prototype.getOverlayFrameStyle = function () {
        var _a, _b, _c, _d;
        var wrapperWidth = this.state.wrapperWidth;
        var wrapperHeight = this.state.wrapperHeight;
        if (!wrapperWidth || !wrapperHeight) {
            return {};
        }
        var frameSizes = this.props.noFrame
            ? null
            : this.props.photo.getFrameSizes(wrapperWidth, wrapperHeight);
        if (!frameSizes) {
            return {};
        }
        var imageUri = this.props.photo.getFrameImageUri();
        return {
            backgroundImage: imageUri ? "url(" + imageUri + ")" : undefined,
            paddingTop: (_a = frameSizes.top) !== null && _a !== void 0 ? _a : 0,
            paddingRight: (_b = frameSizes.right) !== null && _b !== void 0 ? _b : 0,
            paddingBottom: (_c = frameSizes.bottom) !== null && _c !== void 0 ? _c : 0,
            paddingLeft: (_d = frameSizes.left) !== null && _d !== void 0 ? _d : 0,
        };
    };
    return PhotoFrame;
}(React.Component));
export default PhotoFrame;
